import { Post, Direccion, Enlace } from './global.state';

export namespace GlobalActions {
  export class GetInstitucion {
    static readonly type ='[Global] Set Institucion'
    constructor(public slug: string) {}
  }
  export class UpdateScroll {
    static readonly type = '[Global] Update Scroll';
    constructor(public scroll: number) {}
  }
  export class HideFloatMenu {
    static readonly type = '[Global] Hide Float Menu';
    constructor() {}
  }
  export class ShowFloatMenu {
    static readonly type = '[Global] Show Float Menu';
    constructor() {}
  }
  export class ShowLoader {
    static readonly type = '[Global] Show Loader';
    constructor() {}
  }
  export class HideLoader {
    static readonly type = '[Global] Hide Loader';
    constructor() {}
  }
  export class SetThemeColors {
    static readonly type = '[Global] Set Theme Colors';
    constructor(public primary: string, public primaryDark: string, public accent: string) {}
  }
  export class SetLogo {
    static readonly type = '[Global] Set Logo';
    constructor(public logoSrc: string) {}
  }
  export class SetFavicon {
    static readonly type = '[Global] Set Favicon';
    constructor(public faviconSrc: string) {}
  }
  export class SetDatos {
    static readonly type = '[Global] Set Datos';
    constructor(
      public titulo: string,
      public videoconsulta: boolean,
      public contacto: string, 
      public web: string, 
      public ubicacion: any, 
      public telefono: string,
      public facebook: string, 
      public instagram: string, 
      public twitter: string, 
      public whatsapp: string, 
      public youtube: string,
      public direccionGmap: Direccion,
      ) {}
  }
  export class SetBanner {
    static readonly type = '[Global] Set Banner';
    constructor(public banner: string) {}
  }
  export class OpenMap {
    static readonly type = '[Global] Open Map';
    constructor() {}
  }
  export class SetPostsCarrousel {
    static readonly type = ' [Global] Set Posts Carrousel';
    constructor(public postsCarrousel: Post []) {}
  }
  export class CloseMap {
    static readonly type = '[Global] Close Map';
    constructor() {}
  }
  export class LoadLanding {
    static readonly type = '[Global] Load Landing';
    constructor(public slug: string) {}
  }
  export class SetEnlacesEncabezado {
    static readonly type = '[Global] Set Enlaces Encabezado';
    constructor(public enlaces: Enlace[]) { }
  }
  export class SendSubscription {
    static readonly type = '[Global] Send Subscription';
    constructor(public email: string) { }
  }
}
